<ng-container>
  <rt-group class="horizontal stacked">
    <div class="copy-input-wrap">
      <rt-input #copyInput [readOnly]="true" [value]="value">
        <a
          suffix
          rt-icon-button
          *ngIf="hasOpenInNewTabButton"
          (click)="$event.stopImmediatePropagation()"
          [href]="value"
          variant="plain"
          iconName="open-in-new"
          size="small"
          target="_blank"
          shape="square"
        >
        </a>
        <rt-icon-button
          suffix
          *ngIf="hasEditButton"
          (click)="onEdit()"
          variant="plain"
          size="small"
          iconName="edit"
          shape="square"
        >
        </rt-icon-button>
        <rt-icon-button
          suffix
          *ngIf="hasCopyButton"
          (click)="copy(copyInput)"
          variant="plain"
          size="small"
          iconName="content-copy"
          shape="square"
        >
        </rt-icon-button>
      </rt-input>
    </div>
  </rt-group>
</ng-container>
